import { useSearchParams } from 'react-router-dom';
import { useCallback, useMemo } from 'react';
import moment from 'moment';

export const FILTER_PARAMS = {
  from_date: 'fromDate',
  to_date: 'toDate',
  department: 'department',
};

export const getFilterParams = (urlParams= new URLSearchParams(window.location.search)) => {
  const params = {};

  const fromDate = urlParams.get(FILTER_PARAMS.from_date);
  const toDate = urlParams.get(FILTER_PARAMS.to_date);

  if (fromDate && toDate) {
    params.start_dt = moment(fromDate).format('YYYY-MM-DD HH:mm:ss');
    params.end_dt = moment(toDate).format('YYYY-MM-DD HH:mm:ss');
  }

  const department = urlParams.get(FILTER_PARAMS.department);
  if (department) {
    params.department = department;
  }

  return params;
};

export const deleteFilterParamsFromUrl = (prevParams) => {
  Object.values(FILTER_PARAMS).forEach((param) => prevParams.delete(param));
};

export const initSettings = {
  dateRange: {},
  department: [],
};

export const useFiltersUrlState = () => {
  const [params, setParams] = useSearchParams();

  // Get filters from URL
  const filters = useMemo(() => {
    const urlFilters = { ...initSettings };

    // Handle dateRange (fromDate and toDate)
    const fromDate = params.get(FILTER_PARAMS.from_date);
    const toDate = params.get(FILTER_PARAMS.to_date);
    if (fromDate && toDate) {
      urlFilters.dateRange = { fromDate, toDate };
    }

    const department = params.get(FILTER_PARAMS.department);
    if (department) {
      urlFilters.department = [department];
    }

    return urlFilters;
  }, [params]);

  // Set filters in URL
  const setFilters = useCallback(
    (newFilters) => {
      setParams((prev) => {
        // Clear all filter-related params first
        deleteFilterParamsFromUrl(prev);

        // Set new filter params
        if (newFilters.dateRange?.fromDate && newFilters.dateRange?.toDate) {
          prev.set(FILTER_PARAMS.from_date, newFilters.dateRange.fromDate);
          prev.set(FILTER_PARAMS.to_date, newFilters.dateRange.toDate);
        }

        if (!!newFilters.department?.length) {
          prev.set(FILTER_PARAMS.department, newFilters.department[0]);
        }

        return prev;
      });
    },
    [setParams]
  );

  return {
    filters,
    setFilters,
    params,
    setParams,
  };
};
